var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTictactoe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_262)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5218 52.8475C24.3775 52.8475 25.8911 51.3443 25.8911 49.4782C25.8911 47.6225 24.3775 46.1089 22.5218 46.1089C20.6661 46.1089 19.1525 47.6225 19.1525 49.4782C19.1525 51.3339 20.6661 52.8475 22.5218 52.8475ZM22.5218 47.664C23.5171 47.664 24.3361 48.483 24.3361 49.4782C24.3361 50.4735 23.5171 51.2925 22.5218 51.2925C21.5266 51.2925 20.7076 50.4735 20.7076 49.4782C20.7076 48.483 21.5266 47.664 22.5218 47.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4782 21.8911C55.3443 21.8911 56.8475 20.3775 56.8475 18.5218C56.8475 16.6661 55.3339 15.1525 53.4782 15.1525C51.6225 15.1525 50.1089 16.6661 50.1089 18.5218C50.1089 20.3775 51.6225 21.8911 53.4782 21.8911ZM53.4782 16.7075C54.4838 16.7075 55.2924 17.5162 55.2924 18.5218C55.2924 19.517 54.4734 20.3361 53.4782 20.3361C52.4829 20.3361 51.6639 19.517 51.6639 18.5218C51.6639 17.5265 52.4829 16.7075 53.4782 16.7075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3909 21.6527C19.5464 21.8082 19.7434 21.8808 19.9404 21.8808C20.1374 21.8808 20.3343 21.8082 20.4898 21.6527L22.5218 19.6208L24.5538 21.6527C24.7093 21.8082 24.9063 21.8808 25.1032 21.8808C25.3002 21.8808 25.4972 21.8082 25.6527 21.6527C25.9533 21.3521 25.9533 20.8545 25.6527 20.5538L23.6207 18.5218L25.6527 16.4899C25.9533 16.1892 25.9533 15.6916 25.6527 15.391C25.352 15.0903 24.8544 15.0903 24.5538 15.391L22.5218 17.4229L20.4898 15.391C20.1892 15.0903 19.6916 15.0903 19.3909 15.391C19.0903 15.6916 19.0903 16.1892 19.3909 16.4899L21.4229 18.5218L19.3909 20.5538C19.0903 20.8545 19.0903 21.3521 19.3909 21.6527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2225 10H45.7443H30.2557H14.7775C14.3525 10 14 10.3525 14 10.7775V26.2557V41.7339V57.2225C14 57.6475 14.3525 58 14.7775 58H30.2557H45.7339H61.2225C61.6475 58 62 57.6475 62 57.2225V41.7443V26.2557V10.7775C62 10.3525 61.6475 10 61.2225 10ZM29.4782 56.4449H15.5551V42.5218H29.4782V56.4449ZM29.4782 40.9564H15.5551V27.0333H29.4782V40.9564ZM29.4782 25.4782H15.5551V11.5551H29.4782V25.4782ZM44.9564 56.4449H31.0333V42.5218H44.9564V56.4449ZM44.9564 40.9667H31.0333V27.0333H44.9564V40.9667ZM44.9564 25.4782H31.0333V11.5551H44.9564V25.4782ZM60.4449 56.4449H46.5218V42.5218H60.4449V56.4449ZM60.4449 40.9667H46.5218V27.0333H60.4449V40.9667ZM60.4449 25.4782H46.5218V11.5551H60.4449V25.4782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 37.3693C39.8557 37.3693 41.3693 35.8557 41.3693 34C41.3693 32.1443 39.8557 30.6307 38 30.6307C36.1443 30.6307 34.6307 32.1443 34.6307 34C34.6307 35.8557 36.1443 37.3693 38 37.3693ZM38 32.1858C38.9953 32.1858 39.8143 33.0048 39.8143 34C39.8143 34.9953 38.9953 35.8143 38 35.8143C37.0048 35.8143 36.1858 34.9953 36.1858 34C36.1858 33.0048 37.0048 32.1858 38 32.1858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3793 49.4782L50.3473 51.5102C50.0466 51.8108 50.0466 52.3084 50.3473 52.6091C50.5028 52.7646 50.6998 52.8372 50.8968 52.8372C51.0937 52.8372 51.2907 52.7646 51.4462 52.6091L53.4782 50.5771L55.5101 52.6091C55.6657 52.7646 55.8626 52.8372 56.0596 52.8372C56.2566 52.8372 56.4536 52.7646 56.6091 52.6091C56.9097 52.3084 56.9097 51.8108 56.6091 51.5102L54.5771 49.4782L56.6091 47.4462C56.9097 47.1456 56.9097 46.648 56.6091 46.3473C56.3084 46.0467 55.8108 46.0467 55.5101 46.3473L53.4782 48.3793L51.4462 46.3473C51.1456 46.0467 50.6479 46.0467 50.3473 46.3473C50.0466 46.648 50.0466 47.1456 50.3473 47.4462L52.3793 49.4782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_262",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(14 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTictactoe);
export default __webpack_public_path__ + "static/media/tictactoe.4d2f0c67bdc13c88a95b20d52279f3d4.svg";
export { ForwardRef as ReactComponent };